<div>
  <div class="row">
    <div class="col-sm-7 col-md-6">
      <div style="display: flex">
        <h1 class="aru-title">Inspections</h1>
        <app-inspection-search></app-inspection-search>
      </div>
    </div>

    <div class="col-sm-5 col-md-6">
      <tabs [hide]="false" [type]="'flow'" #tabs active="flow"></tabs>
    </div>
  </div>

  <br />
  <br />

  <div id="headers">
    <div>
      <h6>
        Ready to be Assigned <span>({{ noInspector.length }})</span>
      </h6>
    </div>

    <div>
      <h6>
        Inspector Assigned & Ready to be Started <span>({{ ready.length }})</span>
      </h6>
    </div>

    <div>
      <h6>
        Rejected <span>({{ rejected?.length }})</span>
      </h6>
    </div>

    <div>
      <h6>
        Pending ARU's Review <span>({{ pending.length }})</span>
      </h6>
    </div>
  </div>

  <div id="wrapper" #wrapper>
    <div>
      <!-- Ready to be Assigned  -->
      <div class="column">
        <div class="scrollable" forScroll>
          <div *ngIf="noInspector === null" class="spinner-wrapper">
            <span class="spinner"></span>
          </div>
          <ng-container *ngIf="noInspector !== null">
            <div
              class="card-inspection"
              *ngFor="let inspection of noInspector | searchPipe: { searchTerm: this.search }"
              [routerLink]="'/inspection/vendor/form/' + inspection.id">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                  </div>
                  <div>
                    <span class="blue-badge" style="background-color: #db0000"><i class="fa fa-calendar"></i></span>
                    {{ inspection.day }} {{ inspection.month }}
                  </div>
                </div>
              </div>
              <div style="padding-top: 10px">
                <button class="btn btn-link float-left pl-0" (click)="assignInspector($event, inspection)">
                  Assign Inspector
                </button>
                <span style="color: #aaa; line-height: 35px; font-size: 0.9em" class="float-right"
                  >#{{ inspection.policyNumber }}</span
                >
                <br style="clear: both" />
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Inspector Assigned & Ready to be Started -->

      <div class="column">
        <div class="scrollable" forScroll>
          <div *ngIf="ready === null" class="spinner-wrapper">
            <span class="spinner"></span>
          </div>
          <ng-container *ngIf="ready !== null">
            <div
              class="card-inspection"
              [ngClass]="{ 'card-accent-danger': inspection.overdue }"
              *ngFor="let inspection of ready | searchPipe: { searchTerm: this.search }"
              [routerLink]="'/inspection/vendor/form/' + inspection.id">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                  </div>
                  <div
                    style="text-align: right; font-weight: 500; font-size: 1.1em"
                    [ngStyle]="{ color: inspection.overdue ? '#DC3E3E' : '#666' }">
                    <span class="error-badge" *ngIf="inspection.overdue">!</span>
                    <br *ngIf="inspection.overdue" />
                    {{ inspection.day }} {{ inspection.month }}
                    <p *ngIf="inspection.forecasted" style="font-size: 8px; margin-bottom: 0">Forecasted</p>
                  </div>
                </div>
              </div>
              <div style="padding-top: 10px" [style.padding-top]="!inspection.forecasted ? '10px' : '0'">
                <button
                  class="btn btn-link float-left underline"
                  (click)="sendReminderDue($event, inspection)"
                  style="padding: 6px 0">
                  Send reminder
                </button>
                <!-- <button class="btn btn-link float-left" (click)="sendReminderDue($event, inspection)">Send reminder</button> -->
                <span style="color: #aaa; line-height: 35px; font-size: 0.9em" class="float-right"
                  >#{{ inspection.policyNumber }}</span
                >
                <br style="clear: both" />
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Rejected -->

      <div class="column">
        <div class="scrollable" forScroll>
          <div *ngIf="rejected === null" class="spinner-wrapper">
            <span class="spinner"></span>
          </div>
          <ng-container *ngIf="rejected !== null">
            <div
              class="card-inspection"
              [ngClass]="{ 'card-accent-danger': inspection.overdue }"
              *ngFor="let inspection of rejected | searchPipe: { searchTerm: this.search }"
              [routerLink]="'/inspection/vendor/form/' + inspection.id">
              <div>
                <div style="display: flex">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                  </div>
                  <div
                    style="text-align: right; font-weight: 500; font-size: 1.1em"
                    [ngStyle]="{ color: inspection.overdue ? '#DC3E3E' : '#666' }">
                    <span class="error-badge" *ngIf="inspection.overdue">!</span>
                    <br *ngIf="inspection.overdue" />
                    {{ inspection.day }} {{ inspection.month }}
                    <p *ngIf="inspection.forecasted" style="font-size: 8px; margin-bottom: 0">Forecasted</p>
                  </div>
                </div>
              </div>
              <div style="padding-top: 10px" [style.padding-top]="!inspection.forecasted ? '10px' : '0'">
                <button
                  class="btn btn-link float-left underline"
                  (click)="sendReminderDue($event, inspection)"
                  style="padding: 6px 0">
                  Send reminder
                </button>
                <!-- <button class="btn btn-link float-left" (click)="sendReminderDue($event, inspection)">Send reminder</button> -->
                <span style="color: #aaa; line-height: 35px; font-size: 0.9em" class="float-right"
                  >#{{ inspection.policyNumber }}</span
                >
                <br style="clear: both" />
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Pending ARU's Review  -->

      <div class="column">
        <div class="scrollable" forScroll>
          <div *ngIf="pending === null" class="spinner-wrapper">
            <span class="spinner"></span>
          </div>
          <ng-container *ngIf="pending !== null">
            <div
              class="card-inspection"
              [ngClass]="{ 'card-accent-danger': inspection.overdue }"
              *ngFor="let inspection of pending | searchPipe: { searchTerm: this.search }">
              <div>
                <div style="display: flex" [routerLink]="'/inspection/vendor/form/' + inspection.id">
                  <div style="flex: 1">
                    <div class="customer">{{ inspection.customerName }}</div>
                    <div class="text-muted" style="font-size: 0.9em">{{ inspection.city }}, {{ inspection.state }}</div>
                    <div class="text-muted" style="font-weight: 500">
                      {{ inspection.vendor?.name }}
                      <span *ngIf="inspection.inspector">/ {{ inspection.inspector?.name }}</span>
                    </div>
                  </div>

                  <div
                    style="text-align: right; font-weight: 500; font-size: 1.1em; display: ruby"
                    [ngStyle]="{ color: inspection.overdue ? '#DC3E3E' : '#666' }">
                    <span class="error-badge" *ngIf="inspection.overdue && !inspection.lastSynced">!</span>
                    <!-- <span class="error-badge" style="background-color: #ec9006" *ngIf="inspection.lastSynced"
                      ><i class="fa fa-refresh"></i
                    ></span> -->
                    <br *ngIf="inspection.overdue" />
                    <button class="btn btn-pill btn-success float-right" type="button" disabled>
                      {{ getInspectionProgress(inspection.answers).toFixed(0) }}%<br />
                    </button>
                    <p *ngIf="inspection.forecasted" style="font-size: 8px; margin-bottom: 0">Forecasted</p>
                  </div>
                </div>

                <div style="padding-top: 10px" [style.padding-top]="!inspection.forecasted ? '10px' : '0'">
                  <button
                    class="btn btn-link float-left underline"
                    (click)="createReport($event, inspection)"
                    style="padding: 6px 0">
                    Download report
                  </button>

                  <span
                    [routerLink]="'/inspection/vendor/form/' + inspection.id"
                    style="color: #aaa; line-height: 35px; font-size: 0.9em"
                    class="float-right"
                    >#{{ inspection.policyNumber }}</span
                  >
                  <br style="clear: both" />
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <app-assign-inspector-inspection #assignInspectorModal></app-assign-inspector-inspection>
</div>
